export default "__VITE_ASSET__B8s3mMJs__"